import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * Tab row — NeatFit design system: min-height 48px, 2px active underline in the accent colour.
 * The min-height reserves room for tab-specific controls (`actions`, right-aligned) so the
 * row never changes height between tabs.
 */
const UnderlineTabs = ({ tabs, value, onChange, actions, className, disabled = false, label = "Sections" }) => (
  <div className={cn("flex min-h-[48px] flex-wrap items-end justify-between gap-x-4 border-b border-slate-200", className)}>
    <div role="tablist" aria-label={label} className="flex flex-wrap gap-x-6">
      {tabs.map((tab) => {
        const active = tab.id === value
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            id={`tab-${tab.id}`}
            aria-selected={active}
            disabled={disabled}
            onClick={() => onChange(tab.id)}
            className={cn(
              "-mb-px border-b-2 py-3 text-sm transition-colors focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary/25 disabled:cursor-not-allowed disabled:opacity-60",
              active
                ? "border-primary font-semibold text-primary"
                : "border-transparent font-medium text-slate-500 hover:text-slate-900"
            )}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
    {actions && <div className="flex items-center gap-2 pb-2">{actions}</div>}
  </div>
)

export { UnderlineTabs }
